<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.uploadBoardPhotos')"
    width="870px"
    :close-on-click-modal="false"
  >
    <warehouse-pic-grid
      ref="picGrid"
      :model="warehouseIn"
      :show-buttons="false"
      @uploadDone="uploadDoneHandler"
    />
    <span slot="footer" style="display: flex;">
      <el-button type="primary" @click="$refs.picGrid.selectHandler()">{{ $t('queryJob.selectPhotos') }}</el-button>
      <el-button type="primary" @click="$refs.picGrid.deleteHandler()">{{ $t('queryJob.deletePhotos') }}</el-button>
      <div style="flex-grow: 1;" />
      <el-button type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import warehousePicGrid from './warehousePicGrid'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'

export default {
  name: 'UploadLoadingPicDialog',
  components: { warehousePicGrid },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      warehouseIn: new WarehouseIn().fillDefaultValue().getData()
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.job.warehouseIn && this.job.warehouseIn.length > 0) {
          this.warehouseIn = this.job.warehouseIn[0]
        } else {
          new WarehouseIn(this.warehouseIn).fillDefaultValue()
          this.warehouseIn.jobUuid = this.job.uuid
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    enterHandler() {
      // 上传照片
      this.$refs.picGrid.upload()
    },
    uploadDoneHandler() {
      this.$refs.picGrid.submit().then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      })
    }
  }
}
</script>
